import { FiDialogModule } from './../utilities/dialog/dialog.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklistProgressStepperBarComponent } from './progress-stepper-bar/progress-stepper-bar.component';
import { ChecklistService } from './checklist.service';
import { FiChecklistCheckpointAnswerComponent } from './checkpoint-answer/checkpoint-answer.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiChecklistCheckpointAddMediaComponent } from './checkpoint-add-media/checkpoint-add-media.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { ChecklistEditModule } from './edit/edit.module';
import { ChecklistListDataService } from './list/checklist-list-data.service';
import { FiChecklistCheckpointMenuComponent } from './checkpoint-menu/checkpoint-menu.component';
import { FiChecklistCommonModule } from './common/fi-checklist-common.module';
import { FiChecklistCheckpointViewAdditionalInfoComponent } from './checkpoint-view-additional-info/checkpoint-view-additional-info.component';
import { FiChecklistCheckpointViewComponent } from './checkpoint-view/checkpoint-view.component';
import { FiChecklistCheckpointAnswerViewComponent } from './checkpoint-answer-view/checkpoint-answer-view.component';
import { FiChecklistCheckpointViewDialogComponent } from './checkpoint-view-dialog/checkpoint-view-dialog.component';
import { FiChecklistCheckpointAnswerViewStateComponent } from './checkpoint-answer-view-state/checkpoint-answer-view-state.component';
import { FiChecklistViewComponent } from './checklist-view/checklist-view.component';
import { UIRouterModule } from '@uirouter/angular';
import { ChecklistStates } from '@fi-app/checklist/checklist-states';
import { FiBtnUploadFileModule } from '@fi-shared/fi-insert-media/btn-upload-file/btn-upload-file.module';
import { FiMediaBankFileReferencePreviewModule } from '@fi-shared/fi-media-bank-file-reference-preview/fi-media-bank-file-reference-preview.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiElementFocusedModule } from '@fi-shared/fi-directives/fi-element-focused/fi-element-focused.module';
import { FiChecklistEditContainerComponent } from './fi-checklist-edit-container/fi-checklist-edit-container.component';
import { FiChecklist2Module } from '@fi-shared/checklist/fi-checklist2.module';
import { ChecklistV2Module } from '@fi-app/checklist/checklist-v2/checklist-v2.module';
import { ChecklistV2StatesService } from '@fi-app/checklist/checklist-v2/checklist-v2-states.service';
import { FiChecklistStatesService } from '@fi-app/checklist/fi-checklist-states.service';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatInputModule,
        UtilitiesModule,
        ComponentsModule,
        ChecklistV2Module,
        ChecklistEditModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        FiChecklistCommonModule,
        FiDialogModule,
        FiBtnUploadFileModule,
        FiMediaBankFileReferencePreviewModule,
        UIRouterModule.forChild(ChecklistStates),
        FiAttachmentsModule,
        FiElementFocusedModule,
        FiChecklist2Module,
        FiErrorMessageModule,
    ],
    declarations: [
        FiChecklistProgressStepperBarComponent,
        FiChecklistCheckpointAnswerComponent,
        FiChecklistCheckpointAddMediaComponent,
        FiChecklistCheckpointMenuComponent,
        FiChecklistCheckpointViewAdditionalInfoComponent,
        FiChecklistCheckpointViewComponent,
        FiChecklistCheckpointAnswerViewComponent,
        FiChecklistCheckpointViewDialogComponent,
        FiChecklistCheckpointAnswerViewStateComponent,
        FiChecklistViewComponent,
        FiChecklistEditContainerComponent,
    ],
    exports: [FiChecklistProgressStepperBarComponent, FiChecklistViewComponent],
    providers: [ChecklistService, ChecklistListDataService, ChecklistV2StatesService, FiChecklistStatesService],
})
export class ChecklistModule {}
